export const buildPagination = ({
  currentPage,
  totalPages,
  maxButtons = 5,
}) => {
  let startPage = 1;
  let endPage = totalPages;

  if (totalPages > maxButtons) {
    const middle = Math.floor(maxButtons / 2);
    if (currentPage <= middle) {
      startPage = 1;
      endPage = maxButtons;
    } else if (currentPage + middle >= totalPages) {
      startPage = totalPages - maxButtons + 1;
      endPage = totalPages;
    } else {
      startPage = currentPage - middle;
      endPage = currentPage + middle;
    }
  }

  const pages = [];
  for (let i = startPage; i <= endPage; i++) pages.push(i);

  return pages;
};
